export const PRIVACY_SETTINGS_LOCAL_STORAGE_KEY = 'gridPrivacySettings';
